import React from "react";

const TopHeader = ({ children, left, middle, right }) => (
  <header className="top-header">
    <div className="header-new">
      {children || (
        <>
          {left}
          {middle}
          {right}
        </>
      )}
    </div>
  </header>
);

export default TopHeader;
